import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['settingShowOdds']),
    buttonText() {
      return this.settingShowOdds ? 'Show Last Trade Price' : 'Show Implied Odds of Winning';
    },
  },
  methods: {
    ...mapActions('app', ['setSettingShowOdds']),
    onShowOdds() {
      this.setSettingShowOdds(true);
    },
    onDontShowOdds() {
      this.setSettingShowOdds(false);
    },
    onToggle() {
      if (this.settingShowOdds) {
        this.setSettingShowOdds(false);
      } else {
        this.setSettingShowOdds(true);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/price-odds-toggle-popup/price-odds-toggle-popup.js